import React from 'react'
import { Typography, ButtonsList, Button } from '@ann/web-components'
import { MyDriveContainer, MyDriveContent, MyDriveDetailContent, GoToDriveButtonWrapper } from './ListDocumentView.styled'
import SlideoutDocumentCard from '../../../SlideoutDocumentCard'
import { data } from './consts'
import { useStore } from '../../../../../../../../../hooks';
import { observer } from "mobx-react";

const ListDocumentView = observer(({ selectedDocuments, onDocumentSelection, searchTerm }) => {
	const { knowledgeStore } = useStore();
	
	const handleDriveClick = (drive) => {
		knowledgeStore.setSelectedDrive(drive)
	}

	// Filter documents based on search term
	const filteredDocuments = data[0].list.filter(document => 
		document.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
		document.description.toLowerCase().includes(searchTerm.toLowerCase())
	);
	
	return (
		<MyDriveContainer>
			<Typography category="body" size="medium" weight="regular">Drive / { data[0].title }</Typography>
			
			{searchTerm && (
				<Typography category="body" size="small" weight="regular" style={{ marginBottom: '16px', color: '#666' }}>
					{filteredDocuments.length} document{filteredDocuments.length !== 1 ? 's' : ''} found for "{searchTerm}"
				</Typography>
			)}
			
			<MyDriveDetailContent>
				{filteredDocuments.map((document, index) => (
					<SlideoutDocumentCard
						key={document.title}
						id={document.title}
						title={document.title}
						description={document.description}
						ownerName={document.ownerName}
						version={document.version}
						lock={document.lock}
						action={false}
						checked={selectedDocuments.includes(document.title)}
						onChange={(isChecked) => onDocumentSelection(document.title, isChecked)}
					/>
				))}
			</MyDriveDetailContent>
			
			<GoToDriveButtonWrapper>
			<Button label="Go to drive" size="medium" type="primary"/>
			</GoToDriveButtonWrapper>
		</MyDriveContainer>
	)
})

export default ListDocumentView
